module.exports = __webpack_public_path__ + "img/io-5.10fa33fd.jpg";